export function parseDimension(dim: string | number | undefined): number | undefined {
    if (typeof dim === 'string') {
        const candidate = Number.parseInt(dim, 10)
        if (!Number.isNaN(candidate)) {
            return candidate
        }
    } else {
        return dim
    }
}
